<template>
  <div class="flex flex-col name-tabs-wrapper">
    <!-- Tab headers -->
    <div class="tabs border-b border-stone-200 dark:border-stone-700">
      <ul class="flex">
        <li>
          <button @click="activeTab = 0" class="p-4 border-b-2 text-sm"
            :class="activeTab === 0 ? 'text-primary-500 border-primary-500' : 'border-transparent text-stone-600 dark:text-stone-400 hover:text-stone-800 dark:hover:text-stone-200'">
            <span class="flex items-center">
              {{ t('nameTabs.Entries') }}
              <counter-tag :number="entryCount" class="ml-1" />
            </span>
          </button>
        </li>
        <li>
          <button @click="activeTab = 1" class="p-4 border-b-2 text-sm"
            :class="activeTab === 1 ? 'text-primary-500 border-primary-500' : 'border-transparent text-stone-600 dark:text-stone-400 hover:text-stone-800 dark:hover:text-stone-200'">
            <span class="flex items-center">
              {{ t('nameTabs.Results') }}
              <counter-tag :number="winnerCount" class="ml-1" />
            </span>
          </button>
        </li>
        <li>
          <button @click="activeTab = 2" class="p-4 border-b-2 text-sm"
            :class="activeTab === 2 ? 'text-primary-500 border-primary-500' : 'border-transparent text-stone-600 dark:text-stone-400 hover:text-stone-800 dark:hover:text-stone-200'">
            <span>{{ t('nameTabs.Hide') }}</span>
          </button>
        </li>
      </ul>
    </div>

    <!-- Tab content -->
    <div class="tab-content flex-grow overflow-auto">
      <!-- Entries tab -->
      <div v-if="activeTab === 0" class="p-2 flex flex-col h-full">
        <textboxbuttons v-on:reset-wheel-rotation="$emit('reset-wheel-rotation')"></textboxbuttons>
        <textbox v-if="!wheelIsAdvanced" class="flex-grow"></textbox>
        <advancedsliceeditor v-if="wheelIsAdvanced" class="flex-grow"></advancedsliceeditor>
      </div>

      <!-- Results tab -->
      <div v-if="activeTab === 1" class="p-2 flex flex-col h-full">
        <div class="flex flex-wrap gap-2 mb-2">
          <button class="btn btn-secondary btn-sm" @click="sortWinners">
            <i class="fas fa-sort-alpha-up mr-1"></i>{{ t('textboxbuttons.Sort') }}
          </button>
          <button class="btn btn-secondary btn-sm" @click="clearWinners">
            <i class="fas fa-times mr-1"></i>{{ t('nameTabs.Clear the list') }}
          </button>
        </div>
        <winnertextbox class="flex-grow" />
      </div>

      <!-- Hide tab -->
      <div v-if="activeTab === 2" class="p-2 h-full">
        <!-- Hide tab content -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { ref, watch, computed } from 'vue';
import { useWheelStore } from '@/stores/useWheelStore';
import * as Util from '@utils/Util.js';
import counterTag from './counterTag.vue';
import textboxbuttons from './textboxbuttons.vue';
import textbox from './textbox.vue';
import advancedsliceeditor from './advancedSliceEditor.vue';
import winnertextbox from './winnertextbox.vue';

const { t } = useI18n();
const emit = defineEmits(['reset-wheel-rotation']);
const wheelStore = useWheelStore();

const activeTab = ref(0);
watch(activeTab, (val) => {
  Util.trackEvent('Wheel', 'ChangeTab', val);
});

const wheelConfig = computed(() => wheelStore.wheelConfig);
const wheelIsAdvanced = computed(() => wheelConfig.value?.isAdvanced);
const entryCount = computed(() => wheelStore.entryCount);
const winnerCount = computed(() => wheelStore.winnerCount);

function clearWinners() {
  Util.trackEvent('Wheel', 'ClearResults', '');
  wheelStore.clearWinners();
}
function sortWinners() {
  Util.trackEvent('Wheel', 'SortResults', '');
  wheelStore.sortWinners();
}
</script>
<script>
// Options API block removed in favor of <script setup>
</script>

<style scoped>
.name-tabs-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 300px;
  height: 100%;
}

.tab-content {
  flex: 1;
  overflow: auto;
  min-height: 200px;
}
</style>
